import angular = require("angular");
import TPL = require("templates");
import {SessionService} from "../../services/session";
import {ForgotController} from "../../modals/forgot";

export class EmailLoginDirective {

  scope = {
    params: "=params"
  };
  template;
  link;

  constructor(session: SessionService, $modal, $rootScope) {
    this.template = TPL.navigationDirectives.emailLogin;

    this.link = (scope, el, attrs)=> {
        scope.vm = {
          session: session,
          currentModal: scope.params.modal,
          hasFailedLogin: false,
          submit: (form) => {
            if (form.$valid) {
              session.loginWithPassword(scope.vm.email, scope.vm.password)
                .catch((error) => {
                  scope.vm.hasFailedLogin = true;
                });
            }
          },


          openForgotModal: () => {

            scope.vm.hasFailedLogin = false;

            if (scope.vm.currentModal) {
              scope.vm.currentModal.dismiss();
            }

            scope.vm.currentModal = ForgotController.openForgotModal($modal, scope.vm, $rootScope, session);
          }

        };
    }
  }



  static factory() {
    var tmp = (a, b, c) => new EmailLoginDirective(a, b, c);
    tmp.$inject = ["session", "$uibModal", "$rootScope"];
    return tmp;
  }

}



/** WEBPACK FOOTER **
 ** ./src/scripts/directives/navigation/emailLogin.ts
 **/